<template>
  <div>
    <section class="p-4 max-w-7xl mx-auto">
      <h2 class="text-3xl text-gray-700 font-bold lg:text-center te p-4 lg:text-3xl text-[20px] sm:text-[20px]">
        Frequently Asked Questions
      </h2>
      <div class="lg:flex lg:gap-4">
        <div>
          <div data-accordion="collapse" class="text-left">
            <h2 id="accordion-collapse-heading-1" class="pt-4 text-left text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto px-5 py-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b0" data-accordion-target="#accordion-collapse-body-1" aria-expanded="false"
                aria-controls="accordion-collapse-body-1">
                <span class="text-black text-left">Who should enroll in this MCA program?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-1" class="hidden" aria-labelledby="accordion-collapse-heading-1">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2">
                  This program is suitable for:
                Graduates in Computer Applications, Computer Science, IT, or related fields,
                Students aiming for careers in Cloud Computing, Cyber Security, or Infrastructure Engineering
                Learners looking for practical, operations-focused postgraduate education.</p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-2" class="pt-4 text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b1" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false"
                aria-controls="accordion-collapse-body-2">
                <span class="text-black text-left">Is this program more theoretical or practical?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-2" class="hidden" aria-labelledby="accordion-collapse-heading-2">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  It is strongly practical.
                  Most subjects include:
                </p>
                <p class="mb-2">Configuration labs</p>
                <p class="mb-2">Security investigations</p>
                <p class="mb-2">Real enterprise scenarios</p>
                <p class="mb-2">Project-based evaluations</p>
                <p class="mb-2">The final semester is entirely project-focused.</p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-3" class="pt-4 text-left moreBox">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b2" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false"
                aria-controls="accordion-collapse-body-3">
                <span class="text-black text-left">What cloud platforms are covered?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-3" class="hidden" aria-labelledby="accordion-collapse-heading-3">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  Amazon Web Services (AWS) – compute, networking, storage, scaling,
                  Microsoft Azure – hybrid cloud, identity, monitoring, security, backup & Disaster Recovery.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div data-accordion="collapse">
            <h2 id="accordion-collapse-heading-4" class="pt-4 text-left moreBox lg:block hidden">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b3" data-accordion-target="#accordion-collapse-body-4" aria-expanded="false"
                aria-controls="accordion-collapse-body-4">
                <span class="text-black text-left"> What cybersecurity domains are included?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-4" class="hidden" aria-labelledby="accordion-collapse-heading-4">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                  The program covers:
                </p>
                <p class="mb-2 text-left">
                  Ethical Hacking & Penetration Testing
                </p>
                 <p class="mb-2 text-left">
                  Cyber Forensics & Incident Response
                </p>
                 <p class="mb-2 text-left">
                  SOC Operations & SIEM using Splunk
                </p>
                 <p class="mb-2 text-left">
                  Cloud Security Analytics and Compliance
                </p>
              </div>
            </div>
            <h2 id="accordion-collapse-heading-5" class="pt-4 text-left moreBox lg:block hidden">
              <button
                class="flex items-start justify-between w-80 md:w-[480px] xl:w-[600px] mx-auto p-5 border border-gray-200 rounded-xl bg-white dark:bg-white"
                id="b4" data-accordion-target="#accordion-collapse-body-5" aria-expanded="false"
                aria-controls="accordion-collapse-body-5">
                <span class="text-black text-left">Does the program include a project?</span>
                <img src="../assets/about/read-more.png" width="20" alt="" />
              </button>
            </h2>
            <div id="accordion-collapse-body-5" class="hidden" aria-labelledby="accordion-collapse-heading-5">
              <div
                class="p-5 border border-t-0 border-gray-200 w-80 md:w-[480px] xl:w-[600px] mx-auto rounded-b-xl bg-white">
                <p class="mb-2 text-left">
                   Yes.
                   Semester IV consists of a 20-credit project, where students work on:
                </p>
                <p class="mb-2 text-left">
                  Cloud infrastructure design
                </p>
                <p class="mb-2 text-left">
                  Security monitoring and incident analysis
                </p>
                 <p class="mb-2 text-left">    
                   Enterprise IT or cybersecurity use cases
                </p>
              </div>
            </div>

          </div>
        </div>
        <div class="flex justify-center mt-4">
          <div class="flex align-middle place-content-end gap-2 lg:hidden" id="loadMore">

            <button class="readmore-btn text-gray-600"><a href="#">View More</a></button><img
              src="../assets/about/read-more.png" width="25" alt="">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>



<script>
import $ from "jquery";
export default {

  mounted() {
    $(document).ready(function () {
      $(".moreBox").slice(0, 3).show();
      if ($(".accordion-item:hidden").length != 0) {
        $("#loadMore").show();
      }
      $("#loadMore").on("click", function (e) {
        e.preventDefault();
        $(".moreBox:hidden").slice(0, 4).slideDown();
        if ($(".moreBox:hidden").length == 0) {
          $("#loadMore").fadeOut("slow");
        }
      });
    });
  },
}


</script>

<style>
.moreBox,
.moreBox1 {
  font-size: 17px !important;
  font-weight: 400 !important;
}
</style>
